import consumer from "./consumer";

consumer.subscriptions.create("CartChannel", {
  received(data) {
    document.getElementById("cart_items_count").innerText =
      data.cart_items_count;
  },
});
